// extracted by mini-css-extract-plugin
export default {"main":"DetailPageCard--main--Tld6G","detailsSectionRowWrapper":"DetailPageCard--detailsSectionRowWrapper--XEszC"};